import styled from "styled-components";
import { FontSize, ThemesColors } from "@themes/index";
import Sider from "antd/es/layout/Sider";
import { Layout as AntLayout, Menu } from "antd";

const AuthWrapper = styled.div`
    width: 100%;
    display: flex;
    background-color: ${ThemesColors.mainBlueRGB};
`;

const DashboardLogoWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    gap: 30px;

    position: relative;
`;

const MobileCollapseButtonWrapper = styled.div`
    position: absolute;
    top: 14px;
    right: 14px;
    z-index: 1000;
    display: none;

    @media (max-width: 700px) {
        display: block;
    }
`;

const DashboardTitle = styled.h1`
    color: var(--text-base);
    font-size: ${FontSize.ms};
    line-height: 26px;
`;

const SidebarContainer = styled(Sider)`
    min-width: 56px !important;
    width: 100% !important;
    flex: none !important;

    background-color: white;
    box-shadow: rgba(0, 0, 0, 0.15) 0px 2px 8px 0px;

    .ant-menu-light.ant-menu-root.ant-menu-inline {
        border: 0;
    }

    &.ant-layout-sider-collapsed {
        max-width: 56px !important;
    }

    &.ant-layout-sider-dark.ant-layout-sider-collapsed {
        max-width: 56px !important;
    }
`;

const StyledMenu = styled(Menu)`
    width: 100%;
    border-right: none;

    .ant-menu-item-selected {
        background-color: var(--sidebar-active-icon-background) !important;
        border-right: 3px solid var(--sidebar-active-icon) !important;

        .ant-menu-title-content {
            color: var(--sidebar-active-icon) !important;
        }
    }

    .ant-menu {
        background-color: var(--sidebar-background);
    }

    .ant-menu-item {
        min-height: 48px !important;
        min-width: 56px;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100% !important;
        border-radius: 0 !important;
        margin: 0 !important;
        background-color: var(--sidebar-background);
        color: var(--sidebar-inactive-icons);

        &:hover {
            background-color: var(--sidebar-link-hover-background) !important;
            color: var(--sidebar-active-icon) !important;
        }

        &:active {
            background-color: var(--sidebar-active-icon-background) !important;
            color: var(--sidebar-active-icon) !important;
        }
    }

    .ant-menu-submenu-selected {
        .ant-menu-item-icon {
            color: var(--sidebar-active-icon) !important;
        }
    }

    .ant-menu-submenu {
        min-width: 56px;
        width: 100% !important;
        min-height: 48px !important;
        border-radius: 0 !important;
        background-color: var(--sidebar-background);

        .ant-menu-submenu-title {
            &:hover {
                background-color: var(--sidebar-link-hover-background) !important;
            }
        }
    }

    &.ant-menu-inline-collapsed {
        .ant-menu-item {
            .ant-menu-title-content {
                display: none;
            }

            .ant-menu-submenu-title {
                .ant-menu-title-content {
                    display: none;
                }
            }
        }

        .ant-menu-submenu {
            .ant-menu-submenu-title {
                .ant-menu-title-content {
                    display: none;
                }
            }
        }
    }

    .ant-menu-submenu-title {
        margin: 0;
        min-width: 56px;
        width: 100% !important;
        border-radius: 0 !important;
        min-height: 48px !important;
        background-color: var(--sidebar-background);
        color: var(--sidebar-inactive-icons) !important;

        display: flex;
        align-items: center;
        justify-content: center;
    }

    .ant-menu-title-content {
        color: var(--sidebar-inactive-icons);
    }

    .ant-menu-submenu-popup {
        background-color: transparent !important;

        .ant-menu-item-active {
            background-color: var(--sidebar-active-menu-background) !important;
        }

        .ant-menu {
            background-color: var(--sidebar-background) !important;
        }

        .ant-menu-title-content {
            color: var(--sidebar-inactive-icon) !important;
        }

        .ant-menu-item-selected {
            background-color: var(--primary-button-background) !important;
            border-radius: 8px !important;
            width: calc(100% - 8px) !important;
            margin: 4px !important;

            .ant-menu-title-content {
                color: var(--sidebar-active-icon) !important;
            }
        }

        .ant-menu-item {
            .ant-menu-title-content {
                color: var(--sidebar-inactive-icons) !important;
            }
        }
    }
`;

const DashboardLogo = styled.img`
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    width: 150px;
`;

const HeaderOutletWrapper = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
`;

const DashboardCloseWrapper = styled.div`
    text-overflow: clip;
    position: absolute;
    bottom: 0;
    display: flex;
    align-items: center;
    height: 41px;
    border-top: 1px solid #fcfcfd;
    box-shadow: 0px 2px 8px 0px #00000026;
    width: 100%;
    padding-left: 8px;
    transition: all 0.3s;
    width: 100%;
    display: flex;
    background-color: ${ThemesColors.mainBlueRGB};
`;

const CloseSliderContainerClosed = styled(DashboardCloseWrapper)``;

const DashboardLayoutWrapper = styled(AntLayout)`
    min-height: 100vh !important;
`;

const LogoTitleWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 5px;
    padding: 25px 25px 5px 25px;
`;

const SearchFormWrapper = styled.div`
    display: flex;
    width: 100%;
    max-width: 308px;
    margin-left: 10px;
`;

const MobileLogo = styled.div`
    padding: 14px;
    display: flex;
    align-items: center;
    min-height: 64px;

    @media (max-width: 700px) {
        display: none;
    }
`;
export {
    AuthWrapper,
    SearchFormWrapper,
    DashboardTitle,
    StyledMenu,
    SidebarContainer,
    DashboardLogo,
    DashboardLogoWrapper,
    HeaderOutletWrapper,
    CloseSliderContainerClosed,
    DashboardLayoutWrapper,
    LogoTitleWrapper,
    MobileLogo,
    MobileCollapseButtonWrapper,
};
